<template>
  <div class="container-topbar">
    <header id='topbar' :class="`${isSysOnline ? '' : 'bg-danger'}`">
      <div class='row between-xs middle-xs'>
        <div class='col-xs-3 start-xs'>
          <div :class='computedClass'>
            <b-btn
              :variant="`${isSysOnline ? '3v3' : 'danger'}`"
              @click='menu = !menu'
            >
              <menu-icon title=''/>
            </b-btn>

            <warning-basic />

            <span
              v-if="maintenanceModeOn"
              class="maintenance-flag"
              title="Varredura automática desabilitada -- agendas e comandos automáticos não são executados. Desative em Configurações → Firmware."
            >
              ⚠ Manutenção
            </span>

            <strong
              class="d-none d-md-inline-block"
            >
              {{currentSysTime}} {{`${isSysOnline ? '' : '(OFF)'}`}}
            </strong>
          </div>
        </div>
        <div class='col-sm-3 col-xs-12 end-xs center-sm d-flex justify-content-center'>
          <div class='box'>
            <img :src="logo" class="logo">
          </div>
        </div>
        <div v-if="isDev" class='col-sm-2 col-xs-6 end-xs center-sm'>
          <b-form-select v-model="urlSelected">
            <option
              v-for="farm of farmOptions"
              :key="farm.text"
              :value="farm.value"
              :disabled="farm.disabled"
            >
              {{farm.text}}
            </option>
          </b-form-select>
        </div>
        <!-- <strong
          class="d-md-none"
        >
          {{currentSysTime}} {{`${isSysOnline ? '' : '(OFF)'}`}}
        </strong> -->
        
        <div class='col-xs-1 col-sm-3 last-xs end-xs d-flex justify-content-end m-0 p-0 '  v-if="!mobile">
          <div class="local">
            <!-- The vue framework is now dead, don't put a else clause here -->
          <div v-if="hasAssociatedFarms">
            <b-dropdown variant="3v3" :text='local' >
              <b-dropdown-item
                href="#"
              >
                {{local}}
              </b-dropdown-item>

              <b-dropdown-item
                v-for="farm in farmsAssociateds"
                :key="farm.URL"
                :href="farm.URL"
              >
                {{farm.NAME.toUpperCase()}}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div v-if="!hasAssociatedFarms">
            <div class='box locality-info locality'>
              <a class="local" :href="localUrl">  
                <map-marker-icon title=''/>
                  <div class="local-text">
                    <strong>{{ local }} </strong> 
                    <p>{{ activeUser }}</p>
                  </div>
              </a>
            </div>
          </div>
          </div>
          <button class="logout-btn">
            <logout-icon class="logout-icon" @click="$emit('logout')"></logout-icon>
          </button>
        </div>
      </div>
    </header>
    <menu3v3
      @toggle-menu='onToggleMenu'
      @logout='$emit("logout")'
      :shown='menu'
      :is-admin='isAdmin'
      :active-user='activeUser'
      :user-group='userGroup'
      :local='local'
    />
  </div>
</template>

<script>
import WarningBasic from "./WarningBasic.vue";
import { session } from "@/api";
import { isMobile } from "@/pages/components/helpers";
import { isDevelopment } from "@/helpers/development";
import farms_list from "./farms_list";
import moment from "moment";
import { monit } from "@/api";
import { user } from "@/pages/components/globalstore.js"
import { cookies } from "@/pages/components/cookies"

export default {
  name: 'sideNav',
  components: {
    WarningBasic
  },  
  props: {
    isAdmin: Boolean,
    activeUser: [String],
    userGroup: [String],
    local: [String],
    utc: [Number],
    logo: [String],
    parentHideMenu: [Boolean],
    mobile:Boolean
  },
  data() {
    return {
      watchingWarnings: [],
      secondsCounterInterval: null,
      isSysOnline: true,
      rawCurrentSysTime: '',
      farmsAssociateds: null,
      menu: false,
      farmOptions: farms_list,
      urlSelected: null,
      maintenanceModeOn: false,
    }
  },
  watch: {
    urlSelected: {
      handler(newValue) {
        if(newValue && this.isDev) {
          user.doLogout(); 
          window.localStorage.setItem('url', newValue.url);
          window.location.reload();
        }
      }
    },
    parentHideMenu(newValue) {
      if (newValue) {
        this.menu = false;
        this.$emit('reset-hide-menu');
      }
    }
  },
  computed:{
    currentSysTime() {
      const timeFormatt = "DD/MM/YYYY HH:mm";

      return this.rawCurrentSysTime ?
        moment(this.rawCurrentSysTime).format(timeFormatt) :
        moment().format(timeFormatt);
    },
    hasAssociatedFarms() {
      return this.farmsAssociateds && this.farmsAssociateds.length;
    },
    localUrl() {
      return this.isDev && window.localStorage.getItem('url') ?
        window.localStorage.getItem('url') :
        window.location.href;
    },
    isDev() {
      return isDevelopment();
    },
     computedClass(){
      return `${this.menu? "box menu-selected ": "box" } d-flex align-items-center`
    }
  },
  async created() {

    this.farmsAssociateds = await session.getFarmsAssociated();
    await this.getSysTime();

    setInterval(this.getSysTime, 5000);

    // maintenance_mode (SETTINGS_GENERAL_CONFIG, editado em Configurações ->
    // Firmware) desliga a varredura inteira do fw_cir sem nenhum aviso hoje --
    // top-bar é montada em toda tela autenticada, então é o lugar certo pra um
    // sinal visível o tempo todo, não só na tela de Ajustes. Intervalo mais
    // largo que o do relógio (5s) porque esse config muda raro.
    await this.loadMaintenanceMode();
    setInterval(this.loadMaintenanceMode, 30000);
  },
  methods: {
    async loadMaintenanceMode() {
      // Sem token, a chamada 401 -- e um bug antigo à parte (api/index.js:
      // status(), window.setTimeout(location.reload(true), 2000) executa o
      // reload() na hora em vez de esperar 2s, já que reload(true) é chamado
      // e só o retorno dele vira o "callback") transforma isso num reload-loop
      // bem rápido em vez de um logout tranquilo. Mesma guarda que
      // App.vue:checkFirmware() já usa.
      if (!cookies.get("authToken")) return;
      try {
        const ret = await session.getGeneralConfig();
        const cfg = (ret || []).find((c) => c.CFG_KEY === "maintenance_mode");
        this.maintenanceModeOn = !!cfg && cfg.VALUE === "1";
      } catch (err) {
        console.log(err);
      }
    },
    async getSysTime() {
      if(this.$route.path != "/login"){
          try {
          this.rawCurrentSysTime = (await monit.currentTime()).currentTime;
          this.isSysOnline = true;
        } catch(e) {

          this.isSysOnline = false;
          alert('Não foi possível comunicar-se com o sistema', 'e');
        }
      }
     
    },
    isMobile(x) {
      return isMobile(x);
    },
    onToggleMenu(value) {
      this.menu = value;
    }
  }
}
</script>

<style scoped>
.maintenance-flag {
  background-color: var(--orange-color);
  color: #1a1a1a;
  font-weight: bold;
  font-size: 0.75em;
  white-space: nowrap;
  padding: 3px 9px;
  border-radius: 10px;
  margin: 0 20px;
}

.logout-btn{
  border: none;
  background: none;
  cursor: pointer;
  outline: none;
  margin:0;
  color: var(--border-white-color);
  padding: 0;
  display: flex;

}
.container-topbar {
  flex-basis: 65px;
}

.local  {
  margin-right: 1rem;
  display: flex; 
  justify-content: flex-end; 
  align-items: flex-start;
}

.local-text p {
  font-size: 0.8em;
  margin:0px;
}
.local-text p:first-child {
 font-weight: 500;
}

#topbar:not(.bg-danger) .menu-selected > button {
  background-color: #38865a;
}

#topbar.bg-danger .menu-selected > button {
  background-color: #e05663;
}

#topbar {
  color: #fff;
  position: fixed;
  height: var(--size-bars);
  background-color: var(--green-3v3);
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
}
#topbar div.row {
  width: 100%;
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  padding-right: 12px;
}
.locality .material-design-icon {
  padding: 0;
  margin: 0;
  align-self: flex-start;
  vertical-align: -4px;
  transition: all 0.4s ease;
}

.locality-info .local {
  font-weight: 500;
  color: white;
}
@media screen and (max-width: 767px) {
  .locality {
    /* display: none; */
  }
  #topbar {
    height: 65px;
  }
}
</style>
